import apiFetch from "../../../../shared/services/apiClient";

/**
 * createInvoice — POST /api/finance/factura/
 *
 * El campo `cuenta_ingreso` es el ID de la CuentaContable de tipo INGRESO
 * seleccionada en el dropdown de "Rubro". El backend:
 *   1. Detecta si es agua por el nombre de la cuenta
 *   2. Genera el asiento automático: DEBE=CxC filial, HABER=cuenta_ingreso
 */
export async function createInvoice(data) {
  const res = await apiFetch("/api/finance/factura/", {
    method: "POST",
    body: JSON.stringify(data),
  });

  if (!res.ok) {
    try {
      const err = await res.json();
      if (err.detail) throw new Error(err.detail);
      const firstField = Object.keys(err)[0];
      if (firstField) {
        const msg = Array.isArray(err[firstField])
          ? err[firstField][0]
          : err[firstField];
        throw new Error(`${firstField}: ${msg}`);
      }
    } catch (e) {
      if (e.message !== "Error al crear la factura") throw e;
    }
    throw new Error(
      "Error al crear la factura. Revisá los campos e intentá de nuevo.",
    );
  }

  const created = await res.json();
  const id = created.id_factura ?? created.id;

  // GET para obtener el objeto completo
  try {
    const full = await apiFetch(`/api/finance/factura/${id}/`);
    if (full.ok) {
      const facturaCompleta = await full.json();

      // Buscar el asiento generado
      try {
        const asientoRes = await apiFetch(
          `/api/finance/asientos/?search=${facturaCompleta.numero_factura}&page_size=1`,
        );
        if (asientoRes.ok) {
          const asientoData = await asientoRes.json();
          const asientos = asientoData.results ?? [];
          if (asientos.length > 0) {
            facturaCompleta._asiento_generado = asientos[0];
          }
        }
      } catch (_) {}

      return facturaCompleta;
    }
  } catch (_) {}

  return created;
}
